import { updatesData } from '@/mocks/homepage';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-timer-line text-sm"></i>
            </div>
            最新动态
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            平台更新与影视快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            跟进91视频网站、久久视频和91在线视频的最新变化与内容动态
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-200"></div>

          <div className="space-y-8">
            {updatesData.map((item, idx) => (
              <div key={item.id} className="relative pl-10 md:pl-14">
                <div className="absolute left-2 md:left-4 top-1.5 w-4 h-4 rounded-full border-2 border-accent-500 bg-background-50 z-10"></div>

                <div className="bg-background-100 rounded-xl border border-background-200/60 p-5">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2">
                    <span className="inline-block self-start px-2.5 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                    <time className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</time>
                  </div>
                  <h3 className="text-base font-bold text-foreground-900 font-heading mb-1">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}